import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import GlobeIllustration from 'svg/illustrations/Globe';

const Benefits = () => {
  const sections = [
    {
      title: 'Bienestar físico',
      subtitle: 'Entrenamiento, movimiento y hábitos para rendir mejor cada día.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: colors.green,
    },
    {
      title: 'Equilibrio mental',
      subtitle: 'Foco, descanso y gestión del estrés para una vida más consciente.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      color: colors.amber,
    },
    {
      title: 'Nutrición y hábitos',
      subtitle: 'Alimentación consciente y rutinas sostenibles sin extremos.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      ),
      color: colors.orange,
    },
    {
      title: 'Productividad y estilo de vida',
      subtitle: 'Organización, energía y bienestar para profesionales activos.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      color: colors.blue,
    },
    {
      title: 'Recuperación y autocuidado',
      subtitle: 'Descanso, movilidad y prácticas para sostener el rendimiento.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: colors.teal,
    },
    {
      title: 'Marcas con propósito',
      subtitle: 'Patrocinio orgánico en un entorno de confianza y transformación.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      color: colors.purple,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Temas
        </Typography>
        <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h3'} gutterBottom align={'center'} color={'primary'}>
          Bienestar 360° en un solo espacio
        </Box>
        <Typography align={'center'} color="textSecondary" variant={'h6'}>
          Vivir en Equilibrio aborda el bienestar integral: cuerpo, mente y hábitos. Cada eje abre oportunidades de patrocinio temático para marcas de fitness, salud y lifestyle.
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} marginBottom={4} data-aos={'fade-up'}>
        <Box maxWidth={300} width={'100%'}>
          <GlobeIllustration width={'100%'} height={'100%'} />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box height={1} display={'flex'} flexDirection={'column'} data-aos={'fade-up'} data-aos-delay={i * 100}>
              <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} marginBottom={2}>
                <Box component={Avatar} width={60} height={60} marginRight={2} bgcolor={item.color[50]} color={item.color[900]}>
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant={'h6'} gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
